import { render, staticRenderFns } from "./IssuesDetailsMessages.vue?vue&type=template&id=4dfe262e"
import script from "./IssuesDetailsMessages.vue?vue&type=script&lang=js"
export * from "./IssuesDetailsMessages.vue?vue&type=script&lang=js"
import style0 from "./IssuesDetailsMessages.vue?vue&type=style&index=0&id=4dfe262e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports